import _regenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/regenerator.js";
import _asyncToGenerator from "/root/workspace/__flow_work/__flow_builds/50aad046-ad0a-440d-80a1-803b30af1c95/workspace/wellcee-admin_pro/node_modules/.pnpm/@babel/runtime@7.28.6/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import "core-js/modules/es.json.parse.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/web.dom-collections.for-each.js";
export default {
  name: "im-chat-record",
  data: function data() {
    return {
      searchForm: {
        pn: 1,
        ps: 20,
        otherId: this.$route.query.otherId
      },
      // 搜索表单

      tableLoading: false,
      tableData: [],
      // 表格数据
      total: 0,
      userInfo: {},
      message: "",
      imageUrl: "",
      sendImageMessagegDialogVisible: false,
      backVisible: history.length > 1
    };
  },
  mounted: function mounted() {
    var _this = this;
    return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
      return _regenerator().w(function (_context) {
        while (1) switch (_context.n) {
          case 0:
            _this.getData();
            _this.getUserInfo();
          case 1:
            return _context.a(2);
        }
      }, _callee);
    }))();
  },
  methods: {
    textMessageFormat: function textMessageFormat(text) {
      var emojiKeys = ['TUIEmoji_Smile', 'TUIEmoji_Expect', 'TUIEmoji_Blink', 'TUIEmoji_Guffaw', 'TUIEmoji_KindSmile', 'TUIEmoji_Haha', 'TUIEmoji_Cheerful', 'TUIEmoji_Speechless', 'TUIEmoji_Amazed', 'TUIEmoji_Sorrow', 'TUIEmoji_Complacent', 'TUIEmoji_Silly', 'TUIEmoji_Lustful', 'TUIEmoji_Giggle', 'TUIEmoji_Kiss', 'TUIEmoji_Wail', 'TUIEmoji_TearsLaugh', 'TUIEmoji_Trapped', 'TUIEmoji_Mask', 'TUIEmoji_Fear', 'TUIEmoji_BareTeeth', 'TUIEmoji_FlareUp', 'TUIEmoji_Yawn', 'TUIEmoji_Tact', 'TUIEmoji_Stareyes', 'TUIEmoji_ShutUp', 'TUIEmoji_Sigh', 'TUIEmoji_Hehe', 'TUIEmoji_Silent', 'TUIEmoji_Surprised', 'TUIEmoji_Askance', 'TUIEmoji_Ok', 'TUIEmoji_Shit', 'TUIEmoji_Monster', 'TUIEmoji_Daemon', 'TUIEmoji_Rage', 'TUIEmoji_Fool', 'TUIEmoji_Pig', 'TUIEmoji_Cow', 'TUIEmoji_Ai', 'TUIEmoji_Skull', 'TUIEmoji_Bombs', 'TUIEmoji_Coffee', 'TUIEmoji_Cake', 'TUIEmoji_Beer', 'TUIEmoji_Flower', 'TUIEmoji_Watermelon', 'TUIEmoji_Rich', 'TUIEmoji_Heart', 'TUIEmoji_Moon', 'TUIEmoji_Sun', 'TUIEmoji_Star', 'TUIEmoji_RedPacket', 'TUIEmoji_Celebrate', 'TUIEmoji_Bless', 'TUIEmoji_Fortune', 'TUIEmoji_Convinced', 'TUIEmoji_Prohibit', 'TUIEmoji_666', 'TUIEmoji_857', 'TUIEmoji_Knife', 'TUIEmoji_Like'];
      var emojiPattern = /\[TUIEmoji_([^\]]+)\]/g;
      text = text.replace(emojiPattern, function (match, key) {
        console.log(match, key);
        var emojiKey = "TUIEmoji_".concat(key);
        var index = emojiKeys.indexOf(emojiKey);
        if (index > -1) {
          return "<img src=\"https://qnimg1.wellcee.com/emoji/emoji_".concat(index, ".png\" alt=\"").concat(key, "\" style=\"width:30px;display: inline-block;vertical-align: middle;\">");
        } else {
          return match;
        }
      });
      return text;
    },
    convertImgToBase64: function convertImgToBase64(url, callback, outputFormat) {
      var canvas = document.createElement("CANVAS"),
        ctx = canvas.getContext("2d"),
        img = new Image();
      img.crossOrigin = "Anonymous";
      img.onload = function () {
        canvas.height = img.height;
        canvas.width = img.width;
        ctx.drawImage(img, 0, 0);
        var dataURL = canvas.toDataURL(outputFormat || "image/png");
        callback.call(this, dataURL);
        canvas = null;
      };
      img.src = url;
    },
    sendImageMessage: function sendImageMessage() {
      var _this2 = this;
      if (!this.imageUrl) {
        return;
      }
      this.convertImgToBase64(this.imageUrl + (this.imageUrl.indexOf('?') > -1 ? '&' : '?') + "imageView2/2/w/200", /*#__PURE__*/function () {
        var _ref = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(res) {
          var base64;
          return _regenerator().w(function (_context2) {
            while (1) switch (_context2.n) {
              case 0:
                base64 = res.split(",")[1];
                _context2.n = 1;
                return _this2.$api.sendMessage({
                  toUserId: _this2.$route.query.otherId,
                  msg: _this2.imageUrl,
                  type: 7
                  // base64: base64,
                });
              case 1:
                _this2.$message.success("发送成功");
                _this2.imageUrl = "";
                _this2.sendImageMessagegDialogVisible = false;
                _this2.getData();
              case 2:
                return _context2.a(2);
            }
          }, _callee2);
        }));
        return function (_x) {
          return _ref.apply(this, arguments);
        };
      }());
    },
    sendImageMessagegDialog: function sendImageMessagegDialog() {
      this.sendImageMessagegDialogVisible = true;
    },
    sendMessage: function sendMessage() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (_this3.message) {
                _context3.n = 1;
                break;
              }
              _this3.$message.error("请输入消息内容");
              return _context3.a(2, false);
            case 1:
              _context3.n = 2;
              return _this3.$api.sendMessage({
                toUserId: _this3.$route.query.otherId,
                msg: _this3.message,
                type: 1
              });
            case 2:
              _this3.$message.success("发送成功");
              if (_this3.$route.query.from == 'list') {
                // 操作上报
                _this3.$operationLog.push({
                  operationType: "text",
                  code: "send",
                  userId: _this3.$route.query.otherId,
                  detailBatchNo: _this3.message
                });
              }
              _this3.getData();
              _this3.message = "";
            case 3:
              return _context3.a(2);
          }
        }, _callee3);
      }))();
    },
    pageChange: function pageChange(pn) {
      this.searchForm.pn = pn;
      this.getData();
    },
    getUserInfo: function getUserInfo() {
      var _this4 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var res;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return _this4.$api.getUserInfo({
                id: _this4.$route.query.otherId
              });
            case 1:
              res = _context4.v;
              _this4.userInfo = res.data;
            case 2:
              return _context4.a(2);
          }
        }, _callee4);
      }))();
    },
    getData: function getData() {
      var _this5 = this;
      return _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var res;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              _this5.tableLoading = true;
              _context5.n = 1;
              return _this5.$api.getChatRecord(_this5.searchForm);
            case 1:
              res = _context5.v;
              res.data.list.forEach(function (item) {
                if (item.objectName === 'system' && item.msg.indexOf('qnimg1.wellcee') > -1 && item.msg.indexOf('MsgType') == -1) {
                  item.objectName = 'RC:ImgMsg';
                }
                if (item.objectName === 'system' && item.msg && item.msg.indexOf('MsgType') > -1) {
                  item.msg = JSON.parse(item.msg);
                }
              });
              console.log(res.data.list);
              _this5.tableData = res.data.list;
              _this5.total = res.data.count;
              _this5.tableLoading = false;
            case 2:
              return _context5.a(2);
          }
        }, _callee5);
      }))();
    }
  }
};